import Badge from "react-bootstrap/Badge";
import { QuestionProps } from "./Props";
import { snakeToEnglish } from "../Util";

import { useLocalizedStrings } from "../Localization";

function ContractSignerQuestion(props: QuestionProps) {
  const L = useLocalizedStrings();
  const status = props.info[props["Target Field"]!];
  if (status) {
    return (
      <>
        <b>{snakeToEnglish(props["Target Field"]!) + " " + L.questions.contract.status}</b>{" "}
        <h3>
          <Badge variant={status === "signed" ? "success" : "warning"}>
            {snakeToEnglish(status)}
          </Badge>
        </h3>
      </>
    );
  }
  return <></>;
}

export { ContractSignerQuestion };
